const mode = import.meta.env.MODE;

const children = [
  // -- 钱包 --
  {
    path: 'recharge',
    name: 'recharge',
    component: () => import('@/views/profile/recharge/index.vue'),
    meta: {
      locale: 'menu.profile.recharge',
      requiresAuth: true,
      roles: ['*'],
    },
  },

  // -- 订单记录 --
  {
    path: 'place-order-list',
    name: 'place-order-list',
    component: () => import('@/views/users/place-order-list/index.vue'),
    meta: {
      locale: '下单记录',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },
  {
    path: 'receive-order-list',
    name: 'receive-order-list',
    component: () => import('@/views/users/receive-order-list/index.vue'),
    meta: {
      locale: '接单记录',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie'],
    },
  },
  {
    path: 'my-reward-list',
    name: 'my-reward-list',
    component: () => import('@/views/users/my-reward-list/index.vue'),
    meta: {
      locale: '打赏记录',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },
  {
    path: 'my-rewarded-list',
    name: 'my-rewarded-list',
    component: () => import('@/views/users/my-rewarded-list/index.vue'),
    meta: {
      locale: '被打赏记录',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },
  // {
  //   path: 'my-painter-order-list',
  //   name: 'my-painter-order-list',
  //   component: () => import('@/views/painter/my-order-list/index.vue'),
  //   meta: {
  //     locale: '画师订单记录',
  //     hideOn: ['pro_party'],
  //     requiresAuth: true,
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },
  // {
  //   path: 'my-painter-ordered-list',
  //   name: 'my-painter-ordered-list',
  //   component: () => import('@/views/painter/my-ordered-list/index.vue'),
  //   meta: {
  //     locale: '画师接单记录',
  //     hideOn: ['pro_party'],
  //     requiresAuth: true,
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },
  // {
  //   path: 'my-points-order-list',
  //   name: 'my-points-order-list',
  //   component: () => import('@/views/users/my-points-order-list/index.vue'),
  //   meta: {
  //     locale: '积分订单记录',
  //     requiresAuth: true,
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },

  // -- 打赏记录 --

  // -- 财务记录 --
  {
    path: 'my-cacheout-list',
    name: 'my-cacheout-list',
    component: () => import('@/views/users/cacheout-list/index.vue'),
    meta: {
      locale: '提现记录',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },
  // {
  //   path: 'my-tax-list',
  //   name: 'my-tax-list',
  //   component: () => import('@/views/users/my-tax-list/index.vue'),
  //   meta: {
  //     locale: '我的税务信息',
  //     requiresAuth: true,
  //     hideOn: ['pro_party'],
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },

  // -- 商品/购物 --
  // {
  //   path: 'my-cart-order-list',
  //   name: 'my-cart-order-list',
  //   component: () => import('@/views/goods/my-cart-order-list/index.vue'),
  //   meta: {
  //     locale: '购物车',
  //     requiresAuth: true,
  //     hideOn: ['pro_party'],
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },
  // {
  //   path: 'my-goods-order-list',
  //   name: 'my-goods-order-list',
  //   component: () => import('@/views/goods/my-order-list/index.vue'),
  //   meta: {
  //     locale: '商品订单记录',
  //     hideOn: ['pro_party'],
  //     requiresAuth: true,
  //     roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
  //   },
  // },

  // -- 其他 --
  {
    path: 'my-coupon-log-list',
    name: 'my-coupon-log-list',
    component: () => import('@/views/users/coupon-log-list/index.vue'),
    meta: {
      locale: '优惠券领用记录',
      requiresAuth: true,
      roles: ['*'],
    },
  },
  {
    path: 'my-intimacy-list',
    name: 'my-intimacy-list',
    component: () => import('@/views/users/my-intimacy-list/index.vue'),
    meta: {
      locale: '我的亲密好友',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },
  {
    path: 'my-favorites',
    name: 'my-favorites',
    component: () => import('@/views/user/favorites/index.vue'),
    meta: {
      locale: '我的收藏',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service', 'biggie', 'user'],
    },
  },

  // -- 设置 --
  {
    path: 'user-setting',
    name: 'user-setting',
    component: () => import('@/views/users/setting/index.vue'),
    meta: {
      locale: 'menu.user.setting',
      requiresAuth: true,
      roles: ['*'],
    },
  },
];

const filteredChildren = children.filter((child) => {
  if (mode === 'pro_party' && child.meta?.hideOn?.includes('pro_party')) {
    return false;
  }
  return true;
});

export default {
  path: 'user-info',
  name: 'user-info',
  component: () => import('@/views/users/index.vue'),
  meta: {
    locale: 'menu.user',
    icon: 'icon-user',
    requiresAuth: true,
  },
  children: filteredChildren,
};
